import { render, staticRenderFns } from "./rolePermission.vue?vue&type=template&id=21e3a7dc&scoped=true&"
import script from "./rolePermission.vue?vue&type=script&lang=js&"
export * from "./rolePermission.vue?vue&type=script&lang=js&"
import style0 from "./rolePermission.vue?vue&type=style&index=0&id=21e3a7dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e3a7dc",
  null
  
)

export default component.exports